import { render, staticRenderFns } from "./wechat-config.vue?vue&type=template&id=0168e546&scoped=true"
import script from "./wechat-config.vue?vue&type=script&lang=js"
export * from "./wechat-config.vue?vue&type=script&lang=js"
import style0 from "./wechat-config.vue?vue&type=style&index=0&id=0168e546&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168e546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0168e546')) {
      api.createRecord('0168e546', component.options)
    } else {
      api.reload('0168e546', component.options)
    }
    module.hot.accept("./wechat-config.vue?vue&type=template&id=0168e546&scoped=true", function () {
      api.rerender('0168e546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/wechat-config.vue"
export default component.exports